<template>
  <div :class="{disabled}">
    <el-upload
      :action="action"
      :headers="headers"
      :multiple="multiple"
      :data="data"
      :name="name"
      :file-list="fileList"
      :with-credentials="withCredentials"
      :show-file-list="showFileList"
      :drag="drag"
      :accept="accept"
      :on-preview="onPreview||handlePictureCardPreview"
      :on-remove="remove"
      :on-success="success"
      :on-error="onError"
      :on-progress="onProgress"
      :on-change="onChange"
      :before-upload="beforeupload"
      :before-remove="beforeRemove"
      :list-type="listType"
      :auto-upload="autoUpload"
      :http-request="httpRequest"
      :disabled="disabled"
      :limit="limit"
      :on-exceed="onExceed||handleExceed"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
    >
      <img v-default-img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>

<script>
import { Upload, Dialog } from "element-ui";
export default {
  model: {
    prop: "fileList",
    event: "change",
  },
  props: {
    action: {
      required: false,
      type: String,
      default: process.env.uploadUrl,
    }, //	必选参数，上传的地址	String	—	—
    headers: {
      required: false,
      type: Object,
      default: null,
    }, //	设置上传的请求头部	Object	—	—
    multiple: {
      required: false,
      type: Boolean,
      default: true,
    }, //	是否支持多选文件	Boolean	—	—
    data: {
      required: false,
      type: Object,
      default: () => ({
        // 按公司号区分各个公司文件目录
        prefix: localStorage.getItem("companyId") || "tmp",
      }),
    }, //	上传时附带的额外参数	Object	—	—
    name: {
      required: false,
      type: String,
      default: "file",
    }, //	上传的文件字段名	String	—	file
    withCredentials: {
      required: false,
      type: Boolean,
      default: false,
    }, //	支持发送 cookie 凭证信息	Boolean	—	false
    showFileList: {
      required: false,
      type: Boolean,
      default: true,
    }, //	是否显示已上传文件列表	Boolean	—	true
    drag: {
      required: false,
      type: Boolean,
      default: false,
    }, //	是否启用拖拽上传	Boolean	—	false
    accepts: {
      required: false,
      type: String,
      default: "",
    }, //	(非el-upload自带属性,我个人定义)接受上传的文件类型（thumbnail-mode 模式下此参数无效）	String	—	—
    onPreview: {
      required: false,
      type: Function,
    }, //	点击文件列表中已上传的文件时的钩子	function(file)	—	—
    onRemove: {
      required: false,
      type: Function,
      default: () => {},
    }, //	文件列表移除文件时的钩子	function(file, fileList)	—	—
    onSuccess: {
      required: false,
      type: Function,
      default: () => {},
    }, //	文件上传成功时的钩子	function(response, file, fileList)	—	—
    onError: {
      required: false,
      type: Function,
      default: () => {},
    }, //	文件上传失败时的钩子	function(err, file, fileList)	—	—
    onProgress: {
      required: false,
      type: Function,
      default: () => {},
    }, //	文件上传时的钩子	function(event, file, fileList)	—	—
    onChange: {
      required: false,
      type: Function,
    }, //	文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用	function(file, fileList)	—	—
    beforeUpload: {
      required: false,
      type: Function,
      default: () => {},
    }, //	上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。	function(file)	—	—
    beforeRemove: {
      required: false,
      type: Function,
      default: () => {},
    }, //	删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。function(file, fileList)	—	—
    listType: {
      required: false,
      type: String,
      default: "text",
    }, //	文件列表的类型	string	text/picture/picture-card	text
    list: {
      required: false,
      type: String,
      default: "",
    }, //-type	文件列表的类型	String	text/picture/picture-card	text
    autoUpload: {
      required: false,
      type: Boolean,
      default: true,
    }, //	是否在选取文件后立即进行上传	Boolean	—	true
    fileList: {
      required: false,
      type: Array,
    }, //	上传的文件列表, 例如: [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]	Array	—	[]
    httpRequest: {
      required: false,
      type: Function,
    }, //	覆盖默认的上传行为，可以自定义上传的实现	function	—	—
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    }, //	是否禁用	Boolean	—	false
    limit: {
      required: false,
      type: Number,
      default: 15,
    }, //	最大允许上传个数	Number	—	—
    limitSize: {
      required: false,
      type: Number,
      default: 15,
    }, //	(非el-upload自带属性,我个人定义)最大允许上传文件大小	Number(单位MB)	—	—
    onExceed: {
      required: false,
      type: Function,
    }, //	文件超出个数限制时的钩子	function(files, fileList)	—	-
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileType: {
        323: "text/h323",
        acx: "application/internet-property-stream",
        ai: "application/postscript",
        aif: "audio/x-aiff",
        aifc: "audio/x-aiff",
        aiff: "audio/x-aiff",
        asf: "video/x-ms-asf",
        asr: "video/x-ms-asf",
        asx: "video/x-ms-asf",
        au: "audio/basic",
        avi: "video/x-msvideo",
        axs: "application/olescript",
        bas: "text/plain",
        bcpio: "application/x-bcpio",
        bin: "application/octet-stream",
        bmp: "image/bmp",
        c: "text/plain",
        cat: "application/vnd.ms-pkiseccat",
        cdf: "application/x-cdf",
        cer: "application/x-x509-ca-cert",
        class: "application/octet-stream",
        clp: "application/x-msclip",
        cmx: "image/x-cmx",
        cod: "image/cis-cod",
        cpio: "application/x-cpio",
        crd: "application/x-mscardfile",
        crl: "application/pkix-crl",
        crt: "application/x-x509-ca-cert",
        csh: "application/x-csh",
        css: "text/css",
        dcr: "application/x-director",
        der: "application/x-x509-ca-cert",
        dir: "application/x-director",
        dll: "application/x-msdownload",
        dms: "application/octet-stream",
        doc: "application/msword",
        dot: "application/msword",
        dvi: "application/x-dvi",
        dxr: "application/x-director",
        eps: "application/postscript",
        etx: "text/x-setext",
        evy: "application/envoy",
        exe: "application/octet-stream",
        fif: "application/fractals",
        flr: "x-world/x-vrml",
        gif: "image/gif",
        gtar: "application/x-gtar",
        gz: "application/x-gzip",
        h: "text/plain",
        hdf: "application/x-hdf",
        hlp: "application/winhlp",
        hqx: "application/mac-binhex40",
        hta: "application/hta",
        htc: "text/x-component",
        htm: "text/html",
        html: "text/html",
        htt: "text/webviewhtml",
        ico: "image/x-icon",
        ief: "image/ief",
        iii: "application/x-iphone",
        ins: "application/x-internet-signup",
        isp: "application/x-internet-signup",
        jfif: "image/pipeg",
        jpe: "image/jpeg",
        jpeg: "image/jpeg",
        jpg: "image/jpeg",
        js: "application/x-javascript",
        latex: "application/x-latex",
        lha: "application/octet-stream",
        lsf: "video/x-la-asf",
        lsx: "video/x-la-asf",
        lzh: "application/octet-stream",
        m13: "application/x-msmediaview",
        m14: "application/x-msmediaview",
        m3u: "audio/x-mpegurl",
        man: "application/x-troff-man",
        mdb: "application/x-msaccess",
        me: "application/x-troff-me",
        mht: "message/rfc822",
        mhtml: "message/rfc822",
        mid: "audio/mid",
        mny: "application/x-msmoney",
        mov: "video/quicktime",
        movie: "video/x-sgi-movie",
        mp2: "video/mpeg",
        mp3: "audio/mpeg",
        mpa: "video/mpeg",
        mpe: "video/mpeg",
        mpeg: "video/mpeg",
        mpg: "video/mpeg",
        mpp: "application/vnd.ms-project",
        mpv2: "video/mpeg",
        ms: "application/x-troff-ms",
        mvb: "application/x-msmediaview",
        nws: "message/rfc822",
        oda: "application/oda",
        p10: "application/pkcs10",
        p12: "application/x-pkcs12",
        p7b: "application/x-pkcs7-certificates",
        p7c: "application/x-pkcs7-mime",
        p7m: "application/x-pkcs7-mime",
        p7r: "application/x-pkcs7-certreqresp",
        p7s: "application/x-pkcs7-signature",
        pbm: "image/x-portable-bitmap",
        pdf: "application/pdf",
        pfx: "application/x-pkcs12",
        pgm: "image/x-portable-graymap",
        pko: "application/ynd.ms-pkipko",
        pma: "application/x-perfmon",
        pmc: "application/x-perfmon",
        pml: "application/x-perfmon",
        pmr: "application/x-perfmon",
        pmw: "application/x-perfmon",
        pnm: "image/x-portable-anymap",
        png: "image/png",
        "pot,": "application/vnd.ms-powerpoint",
        ppm: "image/x-portable-pixmap",
        pps: "application/vnd.ms-powerpoint",
        ppt: "application/vnd.ms-powerpoint",
        prf: "application/pics-rules",
        ps: "application/postscript",
        pub: "application/x-mspublisher",
        qt: "video/quicktime",
        ra: "audio/x-pn-realaudio",
        ram: "audio/x-pn-realaudio",
        ras: "image/x-cmu-raster",
        rgb: "image/x-rgb",
        rmi: "audio/mid",
        roff: "application/x-troff",
        rtf: "application/rtf",
        rtx: "text/richtext",
        scd: "application/x-msschedule",
        sct: "text/scriptlet",
        setpay: "application/set-payment-initiation",
        setreg: "application/set-registration-initiation",
        sh: "application/x-sh",
        shar: "application/x-shar",
        sit: "application/x-stuffit",
        snd: "audio/basic",
        spc: "application/x-pkcs7-certificates",
        spl: "application/futuresplash",
        src: "application/x-wais-source",
        sst: "application/vnd.ms-pkicertstore",
        stl: "application/vnd.ms-pkistl",
        stm: "text/html",
        svg: "image/svg+xml",
        sv4cpio: "application/x-sv4cpio",
        sv4crc: "application/x-sv4crc",
        swf: "application/x-shockwave-flash",
        t: "application/x-troff",
        tar: "application/x-tar",
        tcl: "application/x-tcl",
        tex: "application/x-tex",
        texi: "application/x-texinfo",
        texinfo: "application/x-texinfo",
        tgz: "application/x-compressed",
        tif: "image/tiff",
        tiff: "image/tiff",
        tr: "application/x-troff",
        trm: "application/x-msterminal",
        tsv: "text/tab-separated-values",
        txt: "text/plain",
        uls: "text/iuls",
        ustar: "application/x-ustar",
        vcf: "text/x-vcard",
        vrml: "x-world/x-vrml",
        wav: "audio/x-wav",
        wcm: "application/vnd.ms-works",
        wdb: "application/vnd.ms-works",
        wks: "application/vnd.ms-works",
        wmf: "application/x-msmetafile",
        wps: "application/vnd.ms-works",
        wri: "application/x-mswrite",
        wrl: "x-world/x-vrml",
        wrz: "x-world/x-vrml",
        xaf: "x-world/x-vrml",
        xbm: "image/x-xbitmap",
        xla: "application/vnd.ms-excel",
        xlc: "application/vnd.ms-excel",
        xlm: "application/vnd.ms-excel",
        xls: "application/vnd.ms-excel",
        xlt: "application/vnd.ms-excel",
        xlw: "application/vnd.ms-excel",
        xof: "x-world/x-vrml",
        xpm: "image/x-xpixmap",
        xwd: "image/x-xwindowdump",
        z: "application/x-compress",
        zip: "application/zip",
        xlsx:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xltx:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
        potx:
          "application/vnd.openxmlformats-officedocument.presentationml.template",
        ppsx:
          "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
        pptx:
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        sldx:
          "application/vnd.openxmlformats-officedocument.presentationml.slide",
        docx:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        dotx:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.12",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
      },
    };
  },
  components: {
    "el-upload": Upload,
    "el-dialog": Dialog,
  },
  computed: {
    accept() {
      return this.accepts
        .split(",")
        .map((accept) => "." + accept)
        .join(",");
    },
  },
  methods: {
    // 上传文件之前的钩子
    beforeupload(file) {
      const isValidate = this.accepts
        .split(",")
        .some((accept) => file.type == this.fileType[accept]);
      const isLtLimitSize = file.size / 1024 / 1024 < this.limitSize;
      if (!isValidate) {
        this.$message.error(`上传格式只能为${this.accepts}!`);
      } else {
        if (!isLtLimitSize) {
          this.$message.error(`上传文件大小不能超过 ${this.limitSize}MB!`);
        }
      }
      return isValidate && isLtLimitSize;
    },
    change(fileList) {
      (fileList || []).forEach(i => {
        i.response.data[0] = i.response.data[0].startsWith('http') || i.response.data[0].startsWith('https') ? i.response.data[0] : (process.env.fileUrl + "/" + i.response.data[0])
      })
      this.$emit("change", fileList);
    },
    success(response, file, fileList) {
      this.change(fileList);
      this.onSuccess(response, file, fileList);
    },
    remove(file, fileList) {
      this.change(fileList);
      this.onRemove(file, fileList);
    },
    handlePictureCardPreview(file) {
      if (this.listType !== "text") {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    },
    handleExceed() {
      this.$message.warning(`最多只能上传${this.limit}个文件`);
    },
  },
  mounted() {
    //console.log("来自publicvuecomponent");
  },
};
</script>

<style lang="less" scoped>
.disabled /deep/ .el-upload {
  cursor: no-drop;
}
</style>



// WEBPACK FOOTER //
// src/components/public/element-secondary/el-upload-secondary/index.vue